module.exports = __webpack_public_path__ + "static/media/mail.7eb508c4.svg";